import { User } from '../types/shared';
import { validateCaptcha } from './validate-captcha';

type UserArgs = {
    email: string;
    password: string;
};

export const logIn = async (userArgs: UserArgs, updateUser: (user: User) => void, recaptchaSiteKey: string, deploymentEnvironment: string, ssoBaseUrl: string) => {
    try {
        const captchaToken = await validateCaptcha('login_user', recaptchaSiteKey);
    
        if (!captchaToken) {
            throw new Error('Captcha validation failed - probably a bot.');
        }
    
        const response = await fetch('/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...userArgs,
                captchaToken,
            }),
        });
    
        if (response.ok) {
            const res = await response.json();
            if (res.success) {
                updateUser(res.user);

                // Redirect to our SSO-base to set shared SSO cookie. But not if user is already on .com
                // And dont bother in local env.
                if (ssoBaseUrl && ssoBaseUrl !== '') {
                    if (deploymentEnvironment === 'production' || deploymentEnvironment === 'stage') {
                        const hostname = window.location.hostname?.replace(/^www\./, '');
                        const isMainSite = hostname === 'atosmedical.com' || hostname === 'stage.atosmedical.24hr.se';
                        if (!isMainSite) {
                            const returnTo = encodeURIComponent(window.location.href);
                            window.location.href = `${ssoBaseUrl}/sso/set-auth-cookie?token=${res.token}&returnTo=${returnTo}`;
                        }
                    }
                }

                return { success: true };
            } else {
                if (res.message === 'user-not-found') {
                    return { success: false, message: 'user-not-found' };
                }
                return { success: false, message: 'invalid-credentials' };
            }
        } else {
            throw new Error('Invalid credentials');
        }
    } catch (error) {
        return { success: false, message: 'invalid-credentials' };
    }
};
